import { AppNS } from 'app';
import ChipList, { ChipsListItem } from 'app/ui_v2/components/chip-list/ChipList';
import AlertCircleIcon from 'app/ui_v2/icons/AlertCircleIcon';

import { Box } from '@mui/material';

export interface UnsafeConditionsProps {
  data: AppNS.JobEventReport;
}
const CONFIG: ChipsListItem[] = [
  {
    id: '1',
    name: (
      <Box display="flex" alignItems="center" fontSize="1rem">
        <AlertCircleIcon sx={{ fontSize: '2rem', color: '#b05e11' }} />
      </Box>
    ),
    tooltip: 'Unsafe Conditions',
  },
];

export default function UnsafeConditions(props: UnsafeConditionsProps) {
  const { data } = props;

  if (!data.unsafeConditions) {
    return null;
  }

  return (
    <Box my={-3}>
      <ChipList list={CONFIG} classNames="warning" />
    </Box>
  );
}
